export type {
  ContextOption,
  ContextSelections,
} from '../../components/ContextSelectionPanel/BaseContextSelectionPanel';
import {
  BaseContextSelectionPanel,
  type ContextDirectory,
} from '../../components/ContextSelectionPanel/BaseContextSelectionPanel';
import type { TAlertRule } from '../../types';
import type { AlertRulesTableStore } from '../AlertRulesTableStore';

export type AlertRuleContextArrayField = Extract<
  {
    [K in keyof TAlertRule]: TAlertRule[K] extends (number | string)[] ? K : never;
  }[keyof TAlertRule],
  string
>;

export type AlertRuleContextDirectory = ContextDirectory<AlertRuleContextArrayField>;

type ContextSelectionPanelProps = {
  selectedRowIds: string[];
  store: AlertRulesTableStore;
  directories: AlertRuleContextDirectory[];
  title?: string;
  onClose?: () => void;
  onResetAll?: () => void;
  className?: string;
  container: HTMLElement;
};

export function AlertRuleContextSelectionPanel({
  selectedRowIds,
  store,
  directories,
  title,
  onClose,
  onResetAll,
  className,
  container,
}: ContextSelectionPanelProps) {
  return (
    <BaseContextSelectionPanel
      selectedRowIds={selectedRowIds}
      store={store}
      directories={directories}
      title={title}
      onClose={onClose}
      onResetAll={onResetAll}
      className={className}
      container={container}
      getFieldValue={(tableStore, rowId, fieldName) => tableStore.getFieldValue(rowId, fieldName)}
      applyFieldValue={(tableStore, rowId, fieldName, values, valueType) => {
        const converted = valueType === 'string' ? values.map(String) : values.map(Number);
        tableStore.onAlertRuleItemValueChange(rowId, fieldName, converted as TAlertRule[AlertRuleContextArrayField]);
      }}
    />
  );
}
